import { useRef, useState } from "react"
import { StepperComponent } from "../../../assets/ts/components"
import { ICreateAppData, defaultCreateAppData } from "../create-app-stepper/IAppModels"
import {createPortal} from 'react-dom'
import { KTSVG } from "../../../helpers"
import { Modal } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { Step1 } from "../create-app-stepper/steps/Step1"

type Props = {
    show: boolean
    handleClose: () => void
    text:string
    link:string
    showbtn:boolean
  }

  const modalsRoot = document.getElementById('root-modals') || document.body

  const TextLinkModal = ({show,handleClose,text,link,showbtn}: Props) => {

    const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const navigate = useNavigate()

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

//   const submit = () => {
//     window.location.reload()
//   }
  return createPortal(
    <Modal
      id='kt_modal_textlink_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-350px'
      show={show}
    //   onHide={handleClose}
      onEntered={loadStepper}
      backdrop={true}
    >


      <div className='modal-body'>
        {/*begin::Stepper */}
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column'
          id='kt_modal_textlink_app_stepper'
        >
          {/*begin::Content */}
          <div className='flex-row-fluid'>
            {/*begin::Form */}
            <form noValidate id='kt_modal_textlink_app_form  flex justify-content-center align-items-center'>
                <h2 className="text-center">{text}</h2>
              {/*begin::Actions */}
              {showbtn ?
                  <div className='d-flex flex-stack flex justify-content-center align-items-center'>
                  <div>
                    <button
                      type='button'
                      className='btn btn-lg btn-primary'
                      data-kt-stepper-action='next'
                      onClick={()=>{navigate(link)}}
                    >
                      OK{' '}
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-1 me-0'
                      />
                    </button>
                  </div>
                </div> 
              :<div></div>
              }
              {/*end::Actions */}
            </form>
            {/*end::Form */}
          </div>
          {/*end::Content */}
        </div>
        {/* end::Stepper */}
      </div>
    </Modal>,
    modalsRoot
  )
  }

  export {TextLinkModal}